import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addEdgeToDecisionTreePath } from '../../../../actions/searchActions';
import {
  extractTicketFromStateById,
  getDecisionNodeAtPath,
  getselectedConversationId,
  getSimplrAccountIdOfSelectedTicket,
} from '../../../../extractFromState';
import { Title, TopContainer } from '../../DecisionTree.styles';
import { Container, InnerContainer, Input, SubText, SubmitButton } from './DTUpdateTicketFieldNode.styles';
import { handleError } from '../../../../services/ErrorService/ErrorService';
import { setLoadingUnique } from '../../../../actions';
import { patchZendeskFields } from '../../../../api/tickets/zendesk';

const DTUpdateTicketFieldNode = () => {
  const dispatch = useDispatch();
  const decisionNode = useSelector(getDecisionNodeAtPath);
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const conversationId = useSelector(getselectedConversationId);
  const { platformTicketId } = useSelector((state) => extractTicketFromStateById(state, conversationId));
  const [ticketFieldValue, setTicketFieldValue] = useState('');
  const setLoading = (value) => dispatch(setLoadingUnique(value, 'DTUpdateTicketFieldNode'));

  const isSubmitButtonActive = () => {
    return ticketFieldValue.length > 0;
  };

  const onNextStep = async () => {
    setLoading(true);
    try {
      await patchZendeskFields({
        simplrAccountId,
        platformTicketId,
        fields: [{ id: decisionNode?.fieldId, value: ticketFieldValue }],
      });
      dispatch(addEdgeToDecisionTreePath('ticket_field_updated'));
    } catch (error) {
      handleError({ error, showPopup: true });
    } finally {
      setLoading(false);
    }
  };

  return (
    <TopContainer>
      <Container>
        {decisionNode?.title && <Title>{decisionNode.title}</Title>}
        {decisionNode?.subText && <SubText>{decisionNode.subText}</SubText>}
        <InnerContainer>
          <Input
            type="text"
            placeholder={`Enter ${decisionNode?.fieldLabel || 'field'} value...`}
            value={ticketFieldValue}
            onChange={(e) => setTicketFieldValue(e.target.value)}
          />
          <SubmitButton
            disabled={!isSubmitButtonActive()}
            active={isSubmitButtonActive()}
            type="submit"
            onClick={onNextStep}
          >
            Submit
          </SubmitButton>
        </InnerContainer>
      </Container>
    </TopContainer>
  );
};

export default DTUpdateTicketFieldNode;
